import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Avatar from '@material-ui/core/Avatar';
import Panel from '../../components/Panel';
import { Key as KeyIcon } from '../../icons';
import KeyManager from '../../components/KeyManager';

const styles = () => ({
  title: {
    display: 'block',
  },
  page: {
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'space-between',
  },
  panelContent: {
    minHeight: 'calc(80vh - 5em)',
    '& *': {
      fontWeight: '500',
    },
    '& [class^="Tree-label"]': {
      '&:hover': {
        color: 'rgb(48,183,255)',
      },
    },
  },
  keys: {
    '& > *': {
      padding: '0.5em 0',
    },
  },
});

const Keys = ({ classes, role }) => (
  <div className={classes.page}>
    <Panel
      id="keysPanel"
      title="Keys"
      classes={{ title: classes.title }}
      avatar={<Avatar><KeyIcon /></Avatar>}
    >
      <div className={classes.panelContent}>
        <KeyManager 
          role={role}
        />
      </div>
    </Panel>
  </div>
);

export default withStyles(styles)(Keys);
